import React from 'react';
import { Row, Col } from 'antd';
import { atom, useAtom } from 'jotai'; 
import { AgencyPageLayout, FlexBox } from '@esg/ui';
import { AgencyDateRangePicker } from '@esg/ui/agency/components/filters';
import { CustomerOverviewContainer, CustomerReportContainer, CustomerDetailContainer } from './Containers';

interface SelectedContext {
    customerId: string;
    branchId: string;
}

const selectedContextAtom = atom<SelectedContext | null>(null);

const scrollableContainerStyle: React.CSSProperties = {
    width: '100%',
    maxHeight: 'calc(100vh - 120px)',
    overflowY: 'auto',
    overflowX: 'hidden', 
    paddingBottom: '24px',
};

const CustomersPage: React.FC = () => {
    const [selectedContext, setSelectedContext] = useAtom(selectedContextAtom);

    return (
        <AgencyPageLayout 
            pageTitle={selectedContext ? 'Customer Details' : 'Customers'} 
            RightExtraContent={!selectedContext && <AgencyDateRangePicker />}
        >
            {selectedContext ? (
                <section style={scrollableContainerStyle}>
                    <CustomerDetailContainer 
                        customerId={selectedContext.customerId}
                        branchId={selectedContext.branchId} 
                        onBack={() => setSelectedContext(null)} 
                    />
                </section>
            ) : (
                <section style={scrollableContainerStyle}>
                    <FlexBox direction='column' gap={12} width="100%">
                        <CustomerOverviewContainer />
                        
                        <Row className="pt-16">
                            <Col span={24}>
                                <CustomerReportContainer 
                                    onSelectCustomer={(customerId, branchId) => 
                                        setSelectedContext({ customerId, branchId })
                                    } 
                                />
                            </Col>
                        </Row>
                    </FlexBox>
                </section>
            )}
        </AgencyPageLayout>
    );
};

export { CustomersPage };